module.exports = __webpack_public_path__ + "img/web7.25c990ec.png";